import { trpc } from '@tencent/tpro_rmonitor_product_manager_llm_oauth';
import { TRPCPost } from '@/infrastructure/axios';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import type { WithTypeCast } from '@raft/utils';

export type IVerifyUserLLMWhiteReq = WithTypeCast<trpc.rmonitor.product_manager.IVerifyUserLLMWhiteReq>;
export type IVerifyUserLLMWhiteRsp = WithTypeCast<trpc.rmonitor.product_manager.IVerifyUserLLMWhiteRsp>;

export class LLMOauthService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: 'trpc.rmonitor.product_manager.LlmOauth',
    });
  }

  /**
   * 验证用户是否在 LLM 白名单中
   * @param req 请求参数
   * @returns 白名单验证结果
   */
  public async verifyUserLLMWhite(req?: IVerifyUserLLMWhiteReq): Promise<IVerifyUserLLMWhiteRsp | null> {
    try {
      return await this.trpcPost<IVerifyUserLLMWhiteRsp>('VerifyUserLLMWhite', req);
    } catch (e) {
      logger.error('verifyUserLLMWhite error:', e);
      return null;
    }
  }

  /**
   * 分发路由请求，获取 agent 值
   * @param input 用户输入和可用 agents 信息
   * @returns 返回 agentValue
   */
  public async dispatchRouter(input: string): Promise<string | null> {
    try {
      const response = await TRPCPost('/copilot/router/dispatch', {
        input,
      }, {
        ignoreError: true,
      });

      return response.agentValue ? `${response.agentValue}` : null;
    } catch (e) {
      logger.error('dispatchRouter error:', e);
      return null;
    }
  }
}

export const llmOauthService = new LLMOauthService();
